import { Observable, Subject } from "rxjs";
import { Injectable } from "@angular/core";
import { SCREEN_SIZE } from "../_helpers/screen-size.enum";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class ResizeService {

  currentSize: SCREEN_SIZE;

  get onResize$(): Observable<SCREEN_SIZE> {
    return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
  }

  private resizeSubject: Subject<SCREEN_SIZE>;

  constructor() {
    this.resizeSubject = new Subject();
  }

  onResize(size: SCREEN_SIZE) {
    this.currentSize = size;
    this.resizeSubject.next(size);
  }

  getDrawerWidth(){
    switch (this.currentSize) {
      case SCREEN_SIZE.XL: {
        return "calc(60vw - 256px)";
      }
      case SCREEN_SIZE.LG: {
        return "calc(60vw - 256px)";
      }
      case SCREEN_SIZE.MD: {
        return "calc(100vw - 256px)";
      }
      default: {
        return "100vw";
      }
    }
  }

  getWideDrawerWidth(){
    switch (this.currentSize) {
      case SCREEN_SIZE.XL: {
        return "calc(90vw - 256px)";
      }
      case SCREEN_SIZE.LG: {
        return "calc(90vw - 256px)";
      }
      case SCREEN_SIZE.MD: {
        return "calc(100vw - 256px)";
      }
      default: {
        return "100vw";
      }
    }
  }

}